import React from "react";
import { Box, Container, Typography } from "@mui/material";
import PageTitle from "../common/PageTitle";
import {
  getAccessDeniedContent,
  type RouteAccessKind,
} from "../../utils/routeAccess";

interface AccessDeniedPageProps {
  access: RouteAccessKind;
}

const AccessDeniedPage: React.FC<AccessDeniedPageProps> = ({ access }) => {
  const content = getAccessDeniedContent(access);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <PageTitle
        pageTitle={content.pageTitle}
        pageDescription={content.pageDescription}
      />
      <Container maxWidth="sm" sx={{ py: 4 }}>
        <Typography color="text.secondary" align="center">
          {content.message}
        </Typography>
      </Container>
    </Box>
  );
};

export default AccessDeniedPage;
